import { trackingStatusDisplayNames } from 'constants/shipping';

import { getString } from 'strings/translation';

export const getTrackingStatusDisplayName = (status: string, language: string) =>
  getString(trackingStatusDisplayNames[status], language);
